<template>
  <div class="child2">
    <el-form
            ref="form"
            :model="form"
            label-width="10px"
            size="small"
    >
      <el-form-item
      >
        流水明细
        <el-divider></el-divider>
      </el-form-item>
      <el-form-item
      >
  <el-table
          :data="tableData"
          v-loading="loading"
          size="small"
          stripe
          highlight-current-row
          style="width: 100%;"
          @selection-change="handleSelectionChange"
          @sort-change="handleSortChange"
  >

    <el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50px">
    </el-table-column>
    <el-table-column
            label="一级代理"
    >
      <template slot-scope="scope">
        {{scope.row.one_agent_name}}
      </template>
    </el-table-column>

    <el-table-column
            label="二级代理"
            :show-overflow-tooltip="true"
    >
      <template slot-scope="scope">
        {{scope.row.two_agent_name}}
      </template>
    </el-table-column>
    <el-table-column
            label="三级代理"
            :show-overflow-tooltip="true"
    >
      <template slot-scope="scope">
        {{scope.row.three_agent_name}}
      </template>
    </el-table-column>
    <el-table-column
            label="商户名称"
            :show-overflow-tooltip="true"
    >
      <template slot-scope="scope">
        {{scope.row.agent_name}}
      </template>
    </el-table-column>
    <el-table-column
            label="订单金额"
    >
      <template slot-scope="scope">
        {{scope.row.order_amount}}
      </template>
    </el-table-column>
    <el-table-column
            label="退款金额"
    >
      <template slot-scope="scope">
        {{scope.row.refund_amount}}
      </template>
    </el-table-column>
    <el-table-column
            label="有效交易基数"
    >
      <template slot-scope="scope">
        {{scope.row.yx_order_amount}}
      </template>
    </el-table-column>
    <el-table-column
            label="顾客实际支付"
    >
      <template slot-scope="scope">
        {{scope.row.payment_amount}}
      </template>
    </el-table-column>

    <el-table-column
            label="操作"
            width="200"
    >
      <template slot-scope="scope">

        <el-button type="primary" plain  size="mini"    @click="openViewForm2(scope.row)">详情</el-button>
        <el-button type="primary" plain  size="mini"    @click="openJyViewForm2(scope.row)">交易明细</el-button>

      </template>
    </el-table-column>

  </el-table>
  <div style="text-align: center;margin-top: 30px;">
    <el-pagination
            :current-page="page.current"
            :page-size="page.size"
            :total="page.total"
            :page-sizes="[1,10,50,100, 200, 300, 400]"
            layout="total, sizes, prev, pager, next, jumper"
            style="margin: -10px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>

      </el-form-item>

    </el-form>

  </div>

</template>

<script>
import * as agentService from '@/api/sys/agent'

import util from '@/libs/util.js'
export default {
  name: 'PayTurnover',
  data () {
    return {
      loading: false,
      start_time: '',
      end_time: '',
      userName: '',
      form: {},
      tableData: [],
      multipleSelection: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: '',
        order: ''
      }
    }
  },
  mounted () {

    //  console.log("========");
    // this.getTableData();
  },
  methods: {
    openViewForm2 (agent) {
      this.$emit('refreshTurnover', agent.agentid)
    },
    openJyViewForm2 (agent) {
      this.$emit('refreshJyTurnover', agent.agentid)
    },
    getTableData () {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
        agentid: util.cookies.get('agentid'),
        dl_type: util.cookies.get('dl_type'),
        xt_id: util.cookies.get('xt_id'),
        start_time: this.start_time,
        end_time: this.end_time,
        agentname: this.userName,
        descending: this.sort.order === 'descending'
      }
      agentService.getMobileOrderPagedlist(query).then(data => {
        this.tableData = data.rows
        this.page.total = data.totalCount
      })
    },
    handleSearchFormSubmit () {
      this.getTableData()
    },
    handleSearchFormReset () {
      this.$refs.searchForm.resetFields()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleSortChange (val) {
      this.sort.prop = val.prop
      this.sort.order = val.order
      this.getTableData()
    },
    handleSizeChange (val) {
      this.page.size = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.current = val
      this.getTableData()
    }
  }
}
</script>
